import {jwtDecode} from 'jwt-decode';

let baseUrl = process.env.REACT_APP_BACKEND_BASE_URL
let socketUrl = process.env.REACT_APP_SOCKET_URL
let paymentUrl = process.env.REACT_APP_PAYMENTS_URL
let azureSpeechKey = process.env.REACT_APP_AZURE_SPEECH_KEY || ''
let azureSpeechRegion = process.env.REACT_APP_AZURE_SPEECH_REGION || ''
let auth0Domain = process.env.REACT_APP_AUTH0_DOMAIN || ''
let auth0ClientID = process.env.REACT_APP_AUTH0_CLIENT_ID || ''
let auth0Audience = process.env.REACT_APP_AUTH0_SPA_AUDIENCE || ''
let azurePubSubEnabled = process.env.REACT_APP_AZURE_PUBSUB_ENABLED === 'true'

const AUTH0_CONFIG_MAP = {
  'localhost:8000': {
    domain: auth0Domain,
    clientId: auth0ClientID,
    audience: auth0Audience,
  },
  'dev-api.pons.io': {
    domain: auth0Domain,
    clientId: auth0ClientID,
    audience: auth0Audience,
  },
  'beta-api.pons.io': {
    domain: auth0Domain,
    clientId: auth0ClientID,
    audience: auth0Audience,
  },
  'demo-api.pons.io': {
    domain: auth0Domain,
    clientId: auth0ClientID,
    audience: auth0Audience,
  },
  'eu-api.pons.io': {
    domain: auth0Domain,
    clientId: auth0ClientID,
    audience: auth0Audience,
  },
};


const getAuth0ConfigFromBackendUrl = (backendUrl) => {
  if (!backendUrl) {
    return AUTH0_CONFIG_MAP['localhost:8000'];
  }

  try {
    const url = new URL(backendUrl);
    const host = url.host; 

    if (AUTH0_CONFIG_MAP[host]) {
      return AUTH0_CONFIG_MAP[host];
    }

    const matchingKey = Object.keys(AUTH0_CONFIG_MAP).find(key => {
      return host.includes(key.split(':')[0]); 
    });

    if (matchingKey) {
      return AUTH0_CONFIG_MAP[matchingKey];
    }

    return AUTH0_CONFIG_MAP['localhost:8000'];
  } catch (error) {
    return AUTH0_CONFIG_MAP['localhost:8000'];
  }
};

const getRedirectUri = () => {
  const backendUrl = baseUrl;

  if (!backendUrl) {
    return window.location.origin;
  }

  try {
    const backendUrlObj = new URL(backendUrl);
    const backendHost = backendUrlObj.host;

    const frontendDomainMap = {
      'localhost:8000': 'http://localhost:3000',
      'dev-api.pons.io': 'https://dev.pons.io',
      'beta-api.pons.io': 'https://beta.pons.io',
      'demo-api.pons.io': 'https://demo.pons.io',
      'eu-api.pons.io': 'https://eu.pons.io',
    };

    if (frontendDomainMap[backendHost]) {
      return frontendDomainMap[backendHost];
    }

    const matchingKey = Object.keys(frontendDomainMap).find(key => {
      return backendHost.includes(key.split(':')[0]);
    });

    if (matchingKey) {
      return frontendDomainMap[matchingKey];
    }

    return window.location.origin;
  } catch (error) {
    return window.location.origin;
  }
};

export const config = {
    baseUrl: baseUrl,
    payment_url: paymentUrl,
    socket_url: socketUrl,
    azure: {
        speechKey: azureSpeechKey,
        speechRegion: azureSpeechRegion,
        pubSubEnabled: azurePubSubEnabled
    },
    pubSub: {
        enabled: azurePubSubEnabled,
        // The actual endpoint and token are retrieved from the backend
        // via the /api/v1/chat/token endpoint
    }
};


export const getAuth0Config = () => {
  const auth0BaseConfig = getAuth0ConfigFromBackendUrl(baseUrl);
  const redirectUri = getRedirectUri();

  return {
    domain: auth0BaseConfig.domain,
    clientId: auth0BaseConfig.clientId,
    audience: auth0BaseConfig.audience,
    redirectUri: redirectUri,
  };
};

/**
 * Check if template features (structure & branding templates) should be enabled.
 * Templates are only available on localhost and dev environments.
 */
export const isTemplatesEnabled = () => {
  const hostname = window.location.hostname;
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname.startsWith('dev.');
};

export const isTokenExpired = (token) => {
    if (!token) return true;
    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    return decodedToken.exp < currentTime;
};
